@if (existingForm) {
  @if (!isWrappedLayout) {
    @for (group of modelArray; track group) {
      @if (group.type === 'form-group') {
        <rs-form-group
          [controls]="group.controls"
          [group]="formGroups.controls[group.name]">
        </rs-form-group>
      }
      @if (group.type === 'group') {
        <rs-consumer-group
          [controls]="group.controls"
          [group]="formGroups.controls[group.name]">
        </rs-consumer-group>
      }
      @if (group.type !== 'form-group') {
        <ng-container
          rsResolve
          [element]="group">
        </ng-container>
      }
    }
    @if (element.submitButtonVisible) {
      <div class="text-center"
        >
        <button type="submit"
          [ngClass]="element.theme?.submitBtn || 'info'"
          [disabled]="!formGroups.valid">
          {{(element.buttonText | translate) || 'Submit'}}
        </button>
      </div>
    }
  } @else {
    <!-- wrap the element in a row to support iterative (row|col) layout -->
    <div class="row">
      @for (group of modelArray; track group) {
        @if (group.type === 'form-group') {
          <rs-form-group
            [controls]="group.controls"
            [group]="formGroups.controls[group.name]">
          </rs-form-group>
        }
        @if (group.type === 'group') {
          <rs-consumer-group
            [controls]="group.controls"
            [group]="formGroups.controls[group.name]">
          </rs-consumer-group>
        }
        @if (group.type !== 'form-group') {
          <ng-container
            rsResolve
            [element]="group">
          </ng-container>
        }
      }
      @if (element.submitButtonVisible) {
        <div class="text-center"
          >
          <button type="submit"
            [ngClass]="element.theme?.submitBtn || 'info'"
            [disabled]="!formGroups.valid">
            {{(element.buttonText | translate) || 'Submit'}}
          </button>
        </div>
      }
    </div>
  }
}
@if (!existingForm) {
  <form
    [formGroup]="formGroups"
    (ngSubmit)="submit()">
    @for (group of modelArray; track group) {
      @if (group.type === 'form-group') {
        <rs-form-group
          [controls]="group.controls"
          [group]="formGroups.controls[group.name]">
        </rs-form-group>
      }
      @if (group.type === 'group') {
        <rs-consumer-group
          [controls]="group.controls"
          [group]="formGroups.controls[group.name]">
        </rs-consumer-group>
      }
      @if (group.type !== 'form-group') {
        <ng-container
          rsResolve
          [element]="group">
        </ng-container>
      }
    }
    @if (element.submitButtonVisible) {
      <div class="text-center"
        >
        <button type="submit"
          [ngClass]="element.theme?.submitBtn || 'info'"
          [disabled]="!formGroups.valid">
          {{(element.buttonText | translate) || 'Submit'}}
        </button>
      </div>
    }
  </form>
}
